import InvoiceOverridablePrice from './InvoiceOverridablePrice';

export default InvoiceOverridablePrice;
